export default "__VITE_ASSET__IojfO3rB__"